import { APP_INITIALIZER, NgModule, isDevMode } from '@angular/core';
import {
  Translation,
  TranslocoModule,
  TranslocoService,
  provideTransloco,
} from '@jsverse/transloco';
import { TranslocoHttpLoader } from './transloco.http-loader';
import { lastValueFrom } from 'rxjs';

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: [
          {
            id: 'uz',
            label: "O/'zbek",
          },
          {
            id: 'ru',
            label: 'Русский',
          },
          {
            id: 'en',
            label: 'English',
          },
          {
            id: 'kr',
            label: 'Qaraqalpaq',
          },
        ],
        defaultLang: 'uz',
        fallbackLang: 'ru',
        reRenderOnLangChange: true,
        prodMode: false,
      },
      loader: TranslocoHttpLoader,
    }),
    {
      provide: APP_INITIALIZER,
      deps: [TranslocoService],
      useFactory:
        (translocoService: TranslocoService): any =>
        (): Promise<Translation> => {
          const defaultLang =
            localStorage.getItem('defaultLang') ??
            translocoService.getDefaultLang();

          translocoService.langChanges$.subscribe(lang =>
            localStorage.setItem('defaultLang', lang)
          );

          translocoService.setActiveLang(defaultLang);

          return lastValueFrom(translocoService.load(defaultLang));
        },
      multi: true,
    },
  ],
})
export class TranslocoLoaderModule {}
